import { jsx } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 -960 960 960", width: 24, ...props, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "m256-168-88-88 224-224-224-224 88-88 224 224 224-224 88 88-224 224 224 224-88 88-224-224-224 224Z" }) });
export default SvgCross;
